import styled from 'styled-components';

export const Wrapper = styled.div`
  width: auto;
  height: auto;
  background: ${(props) => props.theme.colors.primaryDark1};
  /* background:rgb(60,80,224); */
  border-radius: 32px;
  padding: 39px 40px 36px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .text {
    font-weight: 700;
    font-size: 32px;
    color: #fff;
    font-family: ${(props) => props.theme.primaryFont};
    text-align: center;
    line-height: 38px;
    margin-top: 8px;
  }

  .input {
    border-radius: ${(props) =>
      Number(props.theme.borderRadius)
        ? `${props.theme.borderRadius}px`
        : '16px'};
    line-height: 140%;
    padding: 20px;
    font-size: 22px;
    width: 100%;
    margin: 20px 0;
    outline: none;
  }

  .button {
    height: 72px;
    width: 100%;
    border-radius: ${(props) =>
      Number(props.theme.borderRadius)
        ? `${props.theme.borderRadius}px`
        : '16px'};
    background: ${(props) => props.theme.colors.primary};
    outline: none;
    border: none;
    color: #fff;
    font-size: 20px;
    padding: 24px 36px 20px 36px;
    cursor: pointer;
    text-transform: uppercase;
    font-weight: bold;
  }
`;
